<div id="wrapper">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div style="margin-bottom: 0px;">
    <app-tab-nav (updateType)="this.type=$event" 
      (updatePostpaid)="this.postpago=$event"
      (updatePrepaid)="this.prepago=$event" 
      (updateFixed)="this.telefoniaFijo=$event"
      (updateTotalAccountList)="this.totalAccountList=$event" 
      (updateCurrentList)="this.currentList=$event"
      (updateSelectBan)="this.selectBan=$event" 
      (updateInitializeData)="this.initializeData()">
    </app-tab-nav>
  </div>
  <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
  <div class="allcont logsize" *ngIf="this.totalAccountList > 0">
    <div class="basicrow ">
      <div class="container">
        <div *ngIf="type=='postpaid'">
          <div class="basicr-line-i marTopRes">
            <div class="fulltitle f-btitle autodef">
              <span class="icon-dash-25"></span> Mis Equipos y Servicios
            </div>
            <div class="pull-right">
              <label class="label-r sidenmbr vcenter w-auto">
                <span class="tabcell">
                  N&uacute;mero de Cuenta
                </span>
              </label>
              <div class="autorow subsc  mob-wid pull-right">
                <div >
                  <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="type=='fixed'">
          <div class="basicr-line-i marTopRes">
            <div class="fulltitle f-btitle autodef">
              <span class="icon-dash-25"></span> Mis Servicios
            </div>
            <div class="pull-right">
              <label class="label-r sidenmbr vcenter w-auto">
                <span class="tabcell">
                  N&uacute;mero de Cuenta
                </span>
              </label>
              <div class="autorow subsc  mob-wid pull-right">
                <div>
                  <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow" *ngIf="this.postpago== true || this.telefoniaFijo==true">
      <div class="container">
        <div class="basicrow m-top-i">
          <div *ngIf="this.type=='postpaid'">
            <div class="difftabs">
              <div (click)="this.statusChange(1);" [className]="this.selTab===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Detalle de Tu Plan
              </div>
              <div (click)="this.statusChange(2);" [className]="this.selTab===2 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Consulta tu equipo
              </div>
            </div>
          </div>
          <div *ngIf="this.type=='fixed'">
            <div class="difftabs">
              <div (click)="this.statusChange(1);" [className]="this.selTab===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Detalle de Tu Plan
              </div>
            </div>
          </div>
        </div>
        <div id="currentplan" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 1 ? 'block' : 'none' }">
          <div class="basicrow mbott-i">
            <div class="container-currentplan">
              <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt" (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                  <div *ngIf="inf.productTypeField=='G'">
                    <span class="roboto-l">M&Oacute;VIL </span>
                    <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                    <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                    <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                  </div>
                  <div *ngIf="inf.productTypeField=='O'">
                    <span class="roboto-l">TELEFONÍA FIJA </span>
                    <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                    <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                    <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                  </div>
                </div>
                <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                  <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                    <app-currentplan 
                      [index]="i" 
                      [plan_name]="inf.planInfoField.sOCDescriptionField"
                      [quota_val]="inf.equipmentInfoField.installmentValueField"
                      [plan_val]="inf.planInfoField.socRateField"
                      [plan_desc]="inf.planInfoField.sOCDescriptionInfoField"
                      [rental_value]="inf.planInfoField.totalRateField" 
                      [plac_eq]="inf.equipmentInfoField"
                      [add_serv]="inf.servSVAInfoField.servSVAsField"
                      [equ_instal]="inf.equipmentInfoField.installmentsField"
                      [desc_equ]="inf.equipmentInfoField.itemDescriptionField" 
                      [plan_type]="this.type"
                      ></app-currentplan>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Phoneread" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 2 ? 'block' : 'none' }">
          <div class="basicrow mbott-i">
            <div class="container-currentplan">
              <div class="basicrow m-font">
                <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                  <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                    (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                    <div *ngIf="inf.productTypeField=='G'">
                      <span class="roboto-l">M&Oacute;VIL </span>
                      <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                      <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                      <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                    <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                      <app-mobileinfo 
                        [index]="i" 
                        [ph_img]="inf.equipmentInfoField.itemImageField"
                        [desc_equ]="inf.equipmentInfoField.itemDescriptionField"
                        [mark]="inf.equipmentInfoField.itemBrandField"
                        [instal_equ]="inf.equipmentInfoField.installmentsField"
                        [val_ins_equ]="inf.equipmentInfoField.installmentValueField"></app-mobileinfo>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>

